export const MORTGAGE_BANNER_INTEREST_RATE = 0.1;

export const INITIAL_PAYMENT_RATE = 0.2;
export const INITIAL_LOAN_TERM = 20;

export const MAX_LOAN_TERM = 30;
export const MIN_LOAN_TERM = 1;
export const INITIAL_PAYMENT_STEPS_COUNT = 100;

export const VISIBLE_MORTGAGE_PROMOS_COUNT = 5;
